module.exports = {
	currentVersion: 'BETA 0.22.11',
};
